import moment from "moment"
import { Timeline, TimelineProps } from "antd"

import { ICardApplicationTabLogsUI } from "./types"
import { IApplicationCardLogs } from "@api/applications/state.types"

import { Empty, Flex } from "@ui/index"
import imgEmty from '@img/empty.svg'
import { IconClock } from "@img/icons"


/** UI - Вкладка журнал изменений */
export const CardApplicationTabLogsUI = ({ logsList }: ICardApplicationTabLogsUI) => {
    let nextIndex = 0
    const itemsTimeline: TimelineProps['items'] = []

    const getActions = (index: number, list: IApplicationCardLogs[], currentItem: IApplicationCardLogs) => {
        return <>
            <p style={{ display: `${list[index].dataBaseName !== currentItem.dataBaseName ? 'block' : 'none'}` }}>БД сайта 👉 {currentItem.dataBaseName}</p>
            <p style={{ display: `${list[index].clientName !== currentItem.clientName ? 'block' : 'none'}` }}>Клиент 👉 {currentItem.clientName}</p>
            <p style={{ display: `${list[index].clientPhone !== currentItem.clientPhone ? 'block' : 'none'}` }}>Телефон 👉 {currentItem.clientPhone}</p>
            <p style={{ display: `${list[index].clientEmail !== currentItem.clientEmail ? 'block' : 'none'}` }}>Email 👉 {currentItem.clientEmail}</p>
            <p style={{ display: `${list[index].courseName !== currentItem.courseName ? 'block' : 'none'}` }}>Курс 👉 {currentItem.courseName}</p>
            <p style={{ display: `${list[index].programName !== currentItem.programName ? 'block' : 'none'}` }}>Тип программы 👉 {currentItem.programName}</p>
            <p style={{ display: `${list[index].attestationTypeName !== currentItem.attestationTypeName ? 'block' : 'none'}` }}>Тип аттестации 👉 {currentItem.attestationTypeName}</p>
            <p style={{ display: `${list[index].durationEducation !== currentItem.durationEducation ? 'block' : 'none'}` }}>Продолжительность 👉 {currentItem.durationEducation}</p>
            <p style={{ display: `${list[index].volumeHours !== currentItem.volumeHours ? 'block' : 'none'}` }}>Объём 👉 {currentItem.volumeHours}</p>
            <p style={{ display: `${list[index].sum !== currentItem.sum ? 'block' : 'none'}` }}>Стоимость 👉 {currentItem.sum}</p>
            <p style={{ display: `${list[index].startEducationDate !== currentItem.startEducationDate ? 'block' : 'none'}` }}>Начало обучения 👉 {currentItem.startEducationDate}</p>
            <p style={{ display: `${list[index].endEducationDate !== currentItem.endEducationDate ? 'block' : 'none'}` }}>Окончание обучения 👉 {currentItem.endEducationDate}</p>
            <p style={{ display: `${list[index].applicationStatusName !== currentItem.applicationStatusName ? 'block' : 'none'}` }}>Статус заявки 👉 {currentItem.applicationStatusName}</p>
            <p style={{ display: `${list[index].dateNextCall !== currentItem.dateNextCall ? 'block' : 'none'}` }}>Дата отложенного действия 👉 {currentItem.dateNextCall}</p>
            <p style={{ display: `${list[index].timeNextCall !== currentItem.timeNextCall ? 'block' : 'none'}` }}>Время отложенного действия 👉 {currentItem.timeNextCall}</p>
            <p style={{ display: `${list[index].applicationTypeName !== currentItem.applicationTypeName ? 'block' : 'none'}` }}>Тип заявки 👉 {currentItem.applicationTypeName}</p>
            <p style={{ display: `${list[index].applicationSourceName !== currentItem.applicationSourceName ? 'block' : 'none'}` }}>Источник заявки 👉 {currentItem.applicationSourceName}</p>
            <p style={{ display: `${list[index].applicationComment !== currentItem.applicationComment ? 'block' : 'none'}` }}>Коментарий 👉 {currentItem.applicationComment}</p>
            <p style={{ display: `${(list[index].isRepeat !== currentItem.isRepeat || (currentItem.logOperator === '?' && !currentItem.sms)) ? 'block' : 'none'}` }}>Клиент повторно зарегистрировал заявку</p>
            <p style={{ display: `${(list[index].userDemoNameID !== currentItem.userDemoNameID && currentItem.logOperator === '?') ? 'block' : 'none'}` }}>Клиент через сайт запросил демо-доступ</p>
            <p style={{ display: `${(list[index].userDemoCrm !== currentItem.userDemoCrm && currentItem.logOperator !== '?') ? 'block' : 'none'}` }}>Клиенту выдан демо-доступ из ЦРМ</p>
            <p style={{ display: `${list[index].sms !== currentItem.sms ? 'block' : 'none'}` }}>Клиенту отправлена СМС</p>
            
            <p>Нажата кнопка сохранить</p>
        </>
    }

    return <>
        {logsList.value.length === 0 
            ? <Empty image={imgEmty} title="Логи отсутствуют" /> 
            : logsList.value.forEach((item, index) => {
                if ((logsList.value.length - 1) === index) {nextIndex = index} else {nextIndex += 1}

                return <>
                    {itemsTimeline.push({
                        loading: index === 0 ? true : false,

                        icon: (logsList.value.length === (index + 1)) ? <IconClock width="18px" height="18px" color="green" /> : '',
                        
                        title: <>
                            <p>{item.logAction === 'INSERT' ? 'Заявка создана' : 'Заявка изменена'}</p>
                            <div>{item.logOperator === '?' 
                                ? <Flex gap="4px" flexDirection="row" justifyContent="flex-end">
                                    <b>Кем:</b>
                                    <p>Клиентом</p>
                                </Flex> 
                                : <Flex gap="4px" flexDirection="row" justifyContent="flex-end">
                                    <b>Кем:</b>
                                    <p>{item.logOperator}</p>
                                </Flex>
                            }</div>
                            
                            <Flex gap="4px" flexDirection="row" justifyContent="flex-end">
                                <b>Когда:</b>
                                <p>{moment(item.logDate).format('DD.MM.YYYY HH:mm:ss')}</p>
                            </Flex>
                        </>,

                        content: <div>
                            {item.logAction === 'INSERT' 
                                ? 'Заявка зарегистрирована' 
                                : getActions(nextIndex, logsList.value, item)
                            }
                        </div>
                    })}
                </> 
            })
        }

        <Timeline items={itemsTimeline} className="fontStyle" style={{fontWeight: '500'}} />
    </>
}